import React, { useState, useEffect } from "react";

import useBarberAvailability from "../../../hooks/barber/useBarberAvailability.jsx";

import Combobox from "react-widgets/Combobox";
import BarberAvailabilityModal from "./barberAvailibiltyModal.jsx";
import AlertMessage from "../../../components/AlertMessage.jsx";
import DeleteConfirmationModal from "../../../components/DeleteConfirmationModal.jsx";
import Breadcrumb from "../../../components/Breadcrumb.jsx";
import Table from "../../../components/Table/Table.jsx";

import "react-widgets/styles.css";
// fake API call
const BarberAvailabilty = () => {
  const {
    barberList,
    selectedBarber,
    barberAvailabilies,
    message,
    showMessage,
    setShowMessage,
    setSelectedBarber,
    availabilty,
    editId,
    unUsedDays,
    editAvailability,
    onCloseModalClick,
    onAddNewAvailabilty,
    onSave,
    showModal,
    columns,
    setShowModal,
    showDeleteModal,
    onCloseDeleteModal,
    handleDeleteClick,
    handleConfirmDelete,
  } = useBarberAvailability();

  if (barberList == null) {
    return <div>loading...</div>;
  }

  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Staff" child="Available Staff" />
        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}
        <div className="card  p-3 ">
          <div className="row">
            <div className="col-4 form-control-container ">
              <label htmlFor="Barber" className="form-label form-control-label">
                Barber
              </label>
              <Combobox
                onChange={(value) => setSelectedBarber(value)}
                data={barberList}
                dataKey="id"
                textField="name"
                value={selectedBarber}
                defaultValue={selectedBarber}
                containerClassName={" form-combobox"}
              />
            </div>
          </div>
        </div>{" "}
        <BarberAvailabilityModal
          isOpen={showModal}
          onClose={onCloseModalClick}
          onSave={onSave}
          initialData={availabilty}
          unUsedDays={unUsedDays}
        />
        <Table
          columns={columns}
          data={barberAvailabilies}
          onDelete={handleDeleteClick}
          onEdit={editAvailability}
          onAddClick={() => setShowModal(!showModal)}
          title={"All Staff"}
          maxRow={7}
        />
        <DeleteConfirmationModal
          show={showDeleteModal}
          onClose={() => onCloseDeleteModal()}
          onConfirm={handleConfirmDelete}
          message="Are you sure you want to delete this availability?"
        />
      </div>
    </div>
  );
};

export default BarberAvailabilty;
